module.exports = __webpack_public_path__ + "img/phone-active.1da4ca34.svg";